module.exports = __webpack_public_path__ + "img/labtopgif.c2a6b572.gif";